<template>
  <div class="addCompanyTem">
    <p v-if="isAdd" class="titleP">{{ $t('company.addAccount') }}</p>
    <p v-if="!isAdd" class="titleP">{{ $t('company.editAccount') }}</p>
    <el-form ref="addEditAccount" :inline="false" class="dialogForm" :model="popObj" :rules="popRules"
      label-position="left" label-width="auto">
      <el-form-item :label="$t('company.Companyname')" prop="companyName">
        <el-input v-model="popObj.companyName" :disabled="true" @input="change($event)" />
      </el-form-item>
      <el-form-item :label="$t('company.Account')" prop="userLoginName" :class="{'redStart':isAdd}">
        <el-input v-model.trim="popObj.userLoginName" maxlength="30" :disabled="!isAdd" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="isAdd&&!isEditPassword" :label="$t('company.Password')" prop="userPassword" class="redStart">
        <el-input v-model.trim="popObj.userPassword" maxlength="30" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="!isEditPassword" :label="$t('company.Name')" prop="userRealName">
        <el-input v-model="popObj.userRealName" maxlength="30" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="!isEditPassword" :label="$t('company.Email')" prop="userEmail">
        <el-input v-model.trim="popObj.userEmail" maxlength="50" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="!isEditPassword" :label="$t('company.Mobile')" prop="userPhone">
        <el-input v-model="popObj.userPhone" maxlength="20" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="!isEditPassword" :label="$t('company.Role')">
        <el-select v-model="popObj.roleIds" multiple :placeholder="$t('company.Role')">
          <el-option v-for="(item,index) in roleOptions" :key="index" :label="item.value" :value="item.key" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="isGpd && !isEditPassword" :label="$t('company.drmModule')">
        <el-select v-model="popObj.drmModule" multiple>
          <el-option v-for="(item,index) in drmOptions" :key="index" :label="item.label" :value="item.value" />
        </el-select>
        <!-- <el-cascader v-model="popObj.drmModule" :options="drmModuleOptions" :props="props" /> -->
      </el-form-item>

      <!-- <el-form-item v-if="!isEditPassword" :label="$t('company.Guest')" prop="guestFlag">
        <el-radio v-model="popObj.guestFlag" :label="true">{{ $t('allDeviceDetail.Yes') }}</el-radio>
        <el-radio v-model="popObj.guestFlag" :label="false">{{ $t('allDeviceDetail.no') }}</el-radio>
      </el-form-item> -->

      <el-form-item v-if="isEditPassword" :label="$t('company.NewPassword')" class="redStart" prop="userPassword1">
        <el-input v-model.trim="popObj.userPassword1" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="isEditPassword" :label="$t('company.NewPassword')" class="redStart" prop="userPassword2">
        <el-input v-model.trim="popObj.userPassword2" @input="change($event)" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-preventReClick class="filter-item" type="primary"
        @click="submitPop('addEditAccount')">{{ $t('button.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api/user'
import { saveUserInfo, updateById, resetPassword, insertUserAndRoles } from '@/api/company'
import { isArray } from '@/utils/validate'
import { mapState } from 'vuex'
var Base64 = require('js-base64').Base64
export default {
  props: ['userPopInfo', 'isAdd', 'isEditPassword', 'addAccountPopShow', 'roleOptions', 'drmModuleOptions'],
  data () {
    return {
      popObj: {
        companyName: null,
        companyId: null,
        userLoginName: null,
        userPassword: null,
        userRealName: null,
        userEmail: null,
        userPhone: null,
        id: null,
        userPassword1: null,
        userPassword2: null,
        guestFlag: false,
        roleIds: [],
        drmModule: []
      },
      props: { multiple: true }

    }
  },
  computed: {
    ...mapState(['companyId']),
    isGpd () {
      return this.companyId == 4
    },
    popRules () {
      var checkLoginName = (rule, value, callback) => {
        if (this.isAdd) {
          this.checkLoginNameFn(rule, value, callback)
        } else {
          callback()
        }
      }
      var checkPassword = (rule, value, callback) => {
        if (!this.isAdd && !this.isEditPassword) { // 编辑且不是修改密码时
          callback()
        } else { // 新增||修改密码
          this.checkPassFn(rule, value, callback)// 校验密码
        }
      }
      var checkPhone = (rule, value, callback) => {
        if (this.isEditPassword) { // 修改密码时
          callback()
        } else {
          this.checkPhoneFn(rule, value, callback)
        }
      }
      return {
        userLoginName: [{ validator: checkLoginName, trigger: 'blur' }],
        // userPhone: [{ validator: checkPhone, trigger: 'blur' }],
        userPassword: [{ validator: checkPassword, trigger: 'blur' }],
        userPassword1: [{ validator: checkPassword, trigger: 'blur' }],
        userPassword2: [{ validator: checkPassword, trigger: 'blur' }]
      }
    },
    drmOptions () {
      return [
        {
          value: 'yhub',
          label: this.$t('AllDevices.BatteryMonitor') // '电池监控器'
        },
        {
          value: 'charger',
          label: this.$t('AllDevices.charger') // '充电器'
        },
        {
          value: 'kisae',
          label: 'KISAE'
        },
        {
          value: 'Energy',
          label: 'Energy Management'
        },
        {
          value: 'lease',
          label: this.$t('company.LeaseMagt') // '租赁管理'
        },
        {
          value: 'GPDEnergy',
          label: 'GPD Energy Management'
        }
      ]

    }
  },
  watch: {
    // userPopInfo: {
    //   handler (newValue, oldValue) {
    //     console.log('newValue', newValue)
    //     for (var attr in newValue) this.popObj[attr] = newValue[attr]
    //   },
    //   deep: true,
    //   immediate: true
    // },
    // addAccountPopShow (newValue, oldValue) {
    //   console.log('addAccountPopShow', this.addAccountPopShow)
    //   this.popObj.userPassword1 = this.popObj.userPassword2 = null
    //   this.$nextTick(() => {
    //     this.$refs.addEditAccount.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
    //   })
    // }
  },
  mounted () {
    this.initForm()
  },
  methods: {
    initForm () {
      console.log('init---------', this.userPopInfo)
      const info = JSON.parse(JSON.stringify(this.userPopInfo))
      for (const key in info) {
        // console.log(key)
        if (key == 'drmModule') {
          // console.log(info.drmModule)
          if (isArray(info.drmModule)) {
            let drms = []
            info.drmModule.forEach(item => {
              if (isArray(item)) {
                drms.push(item[1])
              }
            })
            this.popObj.drmModule = drms
          }
        }else {
          this.popObj[key] = info[key]

        }
      }
    },
    closePop () { // 新增/编辑用户信息弹窗--关闭
      this.$emit('closePop')
    },
    checkPassFn (rule, value, callback) { // 校验密码
      if (value === '' || !value) {
        callback(new Error(this.$t('lease.Cannotbeblanked2')))
      } else if (value.length < 5 || value.length > 15) { // 长度在5~15之间
        var str = this.$t('company.strLength')
        var newStr = str.replace('$1', '5')
        newStr = newStr.replace('$2', '15')
        callback(new Error(newStr))
      } else {
        if (!/^[^\u4e00-\u9fa5 ]{5,15}$/.test(value)) { // 不能输入中文和空格  {0,}长度不限 {5,15}长度在5-15之间
          callback(new Error(this.$t('company.notEnterChineseSpace')))
        } else {
          // 修改密码，并且两个密码都已输入，且不相同
          if (rule.field == 'userPassword2' && this.isEditPassword && this.popObj.userPassword1 && this.popObj.userPassword2 && this.popObj.userPassword1 != this.popObj.userPassword2) { // 修改密码时
            callback(new Error(this.$t('company.mustSame')))
          } else {
            callback()
          }
        }
      }
    },
    checkPhoneFn (rule, value, callback) { // 校验手机号码
      if (value && !/^((\+)|(\+86))?(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/.test(value)) { // 校验手机
        callback(new Error(this.$t('company.enterRightPhone')))
      } else {
        callback()
      }
    },
    checkLoginNameFn (rule, value, callback) { // 校验账号
      if (value === '' || !value) {
        callback(new Error(this.$t('lease.Cannotbeblanked2')))
      } else if (value.length < 2 || value.length > 30) { // 长度在2~30之间
        var str = this.$t('company.strLength')
        var newStr = str.replace('$1', '2')
        newStr = newStr.replace('$2', '30')
        callback(new Error(newStr))
      } else {
        if (!/^[^\s]*$/.test(value)) { // 不能输入空格
          callback(new Error(this.$t('company.notEnterSpaces')))
        } else {
          callback()
        }
      }
    },
    submitPop (formName) { // 新增/编辑用户信息弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('this.popObj', this.popObj)
          // var param = JSON.parse(JSON.stringify(this.popObj))
          // var drmModuleArr = []
          // if (this.popObj.drmModule) {
          //   this.popObj.drmModule.forEach(v => {
          //     drmModuleArr.push(v[1])
          //   })
          // }
          let param = {
            id: this.popObj.id,
            "allModules": JSON.stringify(this.popObj.drmModule),
            "clientId": "",
            "companyId": this.popObj.companyId,
            "guestFlag": this.popObj.guestFlag,
            "lang": "",
            "modules": '',
            "notifyState": true,
            "phoneType": "",
            "secret": "",
            "userEmail": this.popObj.userEmail,
            "userIdcard": "",
            "userImg": "",
            "userLoginName": this.popObj.userLoginName,
            "userNickName": "",
            "userPassword": this.popObj.userPassword,
            "userPhone": this.popObj.userPhone,
            "userRealName": this.popObj.userRealName,
            "userSalt": "",
            "userSex": "",
            "userState": ""
          }
          
          if (this.isAdd) {
            saveUserInfo({
              "companyId": param.companyId,
              "guestFlag": param.guestFlag,
              "id": param.id,
              "notifyState": true,
              "userEmail": param.userEmail,
              "userLoginName": param.userLoginName,
              "userPassword": param.userPassword,
              "userPhone": param.userPhone,
              "userRealName": param.userRealName
            }).then(res => {
              if (res.resultCode == 1001) {
                this.updateRole(this.popObj.roleIds, res.resultModel)
                this.updateModule(param.allModules, res.resultModel)
                this.successFn()// 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
                // this.closePop() // 新增/编辑用户信息弹窗--关闭
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
            return
          }

          if (this.isEditPassword) { // 修改密码
            resetPassword({
              'password': Base64.encode(this.popObj.userPassword1),
              'userLoginName': this.popObj.userLoginName
            }).then(res => {
              if (res.resultCode == 1001) {
                this.$message({
                  type: 'success',
                  message: this.$t('warningSet.submitted')
                })
                this.closePop()
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
            return
          }
          // 编辑
          console.log('编辑用户信息', param)
          updateById(param).then(res => {
            if (res.resultCode == 1001) {
              this.updateRole(this.popObj.roleIds, this.popObj.id)
              updateById({
                id: param.id,
                modules: param.allModules
              })
              // this.updateModule(drmModuleArr, this.popObj.id)
              this.successFn()// 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
            }
          })
        }
      })
    },
    updateRole (roleIds, userId) { // 更新角色
      var params = {
        'roleIdList': [],
        'userId': userId
      }
      if (roleIds && roleIds.length > 0) {
        roleIds.forEach(v => {
          params.roleIdList.push(v)
        })
      } else {
        return
      }
      insertUserAndRoles(params).then(resp => {
        // this.$emit('closePop', 'needInt')
      })
    },
    updateModule (drmModule, id) { // 更新用户权限
      var param = {
        allModules: drmModule,
        modules: drmModule,
        id: id
      }
      updateById(param).then(res => {
        // if (res.resultCode == 1001) this.$emit('closePop', 'needInt')
      })
    },
    successFn () { // 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
      this.$message({
        message: this.$t('warningSet.submitted'),
        type: 'success'
      })
      this.$emit('closePop', 'needInt')
      // getInfo(this.getToken).then(resp => {
      //   if (resp.resultCode == 1001) {
      //     console.log(this.$store)
          
      //   } else {
      //     this.$message({
      //       type: 'error',
      //       message: resp.resultMessage
      //     })
      //   }
      // })
    },
    change (e) {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.addCompanyTem {
  margin: 0 auto;
  // font-size: 16px;
  .titleP {
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center;
  }
  .btnWarp {
    margin-top: 30px;
  }
  .validWarnP {
    // font-size: 14px;
    color: red;
    line-height: 14px;
    padding-left: 14px;
    // position: absolute;
    // bottom: 0px;
    // right: 0;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-select,
  .el-cascader {
    width: 100%;
  }
}
</style>
